import { Link } from 'react-router-dom'
import { ChevronRight, Handshake } from 'lucide-react'

// Deals a brand offered from a direct-message conversation, shown under the conversation's
// header in each app, linking to the deal in that app.

export interface ThreadDeal {
  id: string
  title: string | null
  status: string
  paymentAmount: number | null
  createdAt: string
}

const STATUS_LABELS: Record<string, string> = {
  offered: 'Offered',
  pending_brand: 'Countered',
  accepted: 'Accepted',
  rejected: 'Declined',
  expired: 'Expired',
}

interface ThreadDealsProps {
  deals: ThreadDeal[]
  /** The deal's page in this app */
  dealPath: (dealId: string) => string
}

export const ThreadDeals = ({ deals, dealPath }: ThreadDealsProps) => {
  if (!deals.length) return null

  return (
    <div className="border-b border-foreground/10 bg-[#C0FD72]/5 px-4 py-2 space-y-1 shrink-0">
      {deals.map((deal) => (
        <Link
          key={deal.id}
          to={dealPath(deal.id)}
          className="flex items-center gap-2 text-sm text-gray-800 hover:text-foreground"
        >
          <Handshake className="h-4 w-4 shrink-0 text-[#4d7c0f]" />
          <span className="truncate">
            {deal.title ?? 'Deal'}
            {deal.paymentAmount !== null && ` · $${deal.paymentAmount.toLocaleString()}`}
          </span>
          <span className="ml-auto shrink-0 text-xs text-[#4d7c0f]">
            {STATUS_LABELS[deal.status] ?? deal.status}
          </span>
          <ChevronRight className="h-4 w-4 shrink-0 text-gray-500" />
        </Link>
      ))}
    </div>
  )
}
